<ngx-select [allowClear]="false" [items]="items" optionValueField="value" optionTextField="name"
    [autoClearSearch]="false" [(ngModel)]="productGasoline" placeholder="Seleccionar Producto"
    (select)="changeProductGasoline($event)">

    <ng-template ngx-select-option-not-found let-input>
        "{{input}}" no encontrado
    </ng-template>

</ngx-select>